import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { heatingControlsLp } from "@/content/landing/heating-controls";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const LpHeatingControlsPage = lazyNamed(
  () => import("@/components/landing/lp-heating-controls"),
  "LpHeatingControls",
);

const PATH = "/heating-controls";
const TITLE = "Heating Controls & Smart Thermostats South Wales | Gas Safe | CRS Energy";
const DESCRIPTION =
  "Smart thermostats, TRVs, zoning and load compensation across South Wales. Gas Safe Registered, MCS Accredited, manufacturer-backed warranty. Free assessment, no obligation.";

export const Route = createFileRoute("/heating-controls")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: "Heating Controls",
        description: DESCRIPTION,
        serviceType: "Heating Controls",
        url: `${SITE.url}${PATH}`,
        image: SERVICE_PAGE_OG_IMAGES[PATH],
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: heatingControlsLp.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: LpHeatingControlsPage,
});
